import { render } from "./basicsetup.vue?vue&type=template&id=11fcc0ce&scoped=true"
import script from "./basicsetup.vue?vue&type=script&lang=js"
export * from "./basicsetup.vue?vue&type=script&lang=js"

import "./basicsetup.vue?vue&type=style&index=0&id=11fcc0ce&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11fcc0ce"

export default script